<!-- Backdrop -->
<div
  *ngIf="sidebarService.isExpanded$ | async"
  class="backdrop"
  [class.show]="sidebarService.isExpanded$ | async"
  (click)="sidebarService.toggleSidebar()"
></div>

<aside
  [class.expanded]="sidebarService.isExpanded$ | async"
  class="flex flex-col bg-[#FDFDFD] shadow-sm overflow-hidden rounded-[33px]"
>
  <div class="h-24 flex items-center justify-between px-8 mb-[25px]">
    <img
      src="assets/authoritie-logo.svg"
      width="200"
      height="auto"
      loading="eager"
      class="w-auto h-auto mobile-logo"
      alt="Authoritie"
    />
  </div>

  <!-- Navigation -->
  <nav class="flex-1 px-6 space-y-4">
    <a
      routerLink="dashboard"
      [routerLinkActiveOptions]="{ exact: true }"
      routerLinkActive="bg-[#F1E4F8] !text-[#AB54DB] [&_svg]:!text-[#AB54DB]"
      class="flex items-center px-4 py-3 text-slate-600 rounded-xl hover:bg-gray-50 group text-base font-medium"
      (click)="sidebarService.toggleSidebar()"
    >
      <svg
        viewBox="0 0 28 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="h-5 w-5 mr-4 text-[#B9BBBD]"
        stroke="currentColor"
        stroke-width=".5"
      >
        <path
          d="M3.5 9.33305V23.3331C3.5 23.6425 3.62292 23.9392 3.84171 24.158C4.0605 24.3768 4.35725 24.4997 4.66667 24.4997H10.5C10.8094 24.4997 11.1062 24.3768 11.325 24.158C11.5437 23.9392 11.6667 23.6425 11.6667 23.3331V15.1664H16.3333V23.3331C16.3333 23.6425 16.4563 23.9392 16.675 24.158C16.8938 24.3768 17.1906 24.4997 17.5 24.4997H23.3333C23.6428 24.4997 23.9395 24.3768 24.1583 24.158C24.3771 23.9392 24.5 23.6425 24.5 23.3331V9.33305C24.5 9.15193 24.4578 8.9733 24.3768 8.8113C24.2958 8.6493 24.1782 8.50839 24.0333 8.39972L14.7 1.39972C14.4981 1.24826 14.2524 1.16638 14 1.16638C13.7476 1.16638 13.5019 1.24826 13.3 1.39972L3.96667 8.39972C3.82177 8.50839 3.70417 8.6493 3.62317 8.8113C3.54217 8.9733 3.5 9.15193 3.5 9.33305ZM5.83333 9.91638L14 3.79138L22.1667 9.91638V22.1664H18.6667V13.9997C18.6667 13.6903 18.5437 13.3936 18.325 13.1748C18.1062 12.956 17.8094 12.8331 17.5 12.8331H10.5C10.1906 12.8331 9.89383 12.956 9.67504 13.1748C9.45625 13.3936 9.33333 13.6903 9.33333 13.9997V22.1664H5.83333V9.91638Z"
          fill="currentColor"
        />
      </svg>
      Dashboard
    </a>

    <a
      routerLink="recent-ads"
      [routerLinkActiveOptions]="{ exact: true }"
      routerLinkActive="bg-[#F1E4F8] !text-[#AB54DB] [&_svg]:!text-[#AB54DB]"
      class="flex items-center px-4 py-3 text-slate-600 rounded-xl hover:bg-gray-50 group text-base font-medium"
      (click)="sidebarService.toggleSidebar()"
    >
      <svg
        class="h-5 w-5 mr-4 text-[#B9BBBD]"
        stroke="currentColor"
        viewBox="0 0 28 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        stroke-width="0.5"
      >
        <path
          d="M4.66667 12.8333H11.6667C11.9761 12.8333 12.2728 12.7104 12.4916 12.4916C12.7104 12.2728 12.8333 11.9761 12.8333 11.6667V4.66667C12.8333 4.35725 12.7104 4.0605 12.4916 3.84171C12.2728 3.62292 11.9761 3.5 11.6667 3.5H4.66667C4.35725 3.5 4.0605 3.62292 3.84171 3.84171C3.62292 4.0605 3.5 4.35725 3.5 4.66667V11.6667C3.5 11.9761 3.62292 12.2728 3.84171 12.4916C4.0605 12.7104 4.35725 12.8333 4.66667 12.8333ZM5.83333 5.83333H10.5V10.5H5.83333V5.83333Z"
          fill="currentColor"
        />
        <path
          d="M16.3332 12.8333H23.3332C23.6426 12.8333 23.9393 12.7104 24.1581 12.4916C24.3769 12.2728 24.4998 11.9761 24.4998 11.6667V4.66667C24.4998 4.35725 24.3769 4.0605 24.1581 3.84171C23.9393 3.62292 23.6426 3.5 23.3332 3.5H16.3332C16.0238 3.5 15.727 3.62292 15.5082 3.84171C15.2894 4.0605 15.1665 4.35725 15.1665 4.66667V11.6667C15.1665 11.9761 15.2894 12.2728 15.5082 12.4916C15.727 12.7104 16.0238 12.8333 16.3332 12.8333ZM17.4998 5.83333H22.1665V10.5H17.4998V5.83333Z"
          fill="currentColor"
        />
        <path
          d="M4.66667 24.5001H11.6667C11.9761 24.5001 12.2728 24.3772 12.4916 24.1584C12.7104 23.9396 12.8333 23.6428 12.8333 23.3334V16.3334C12.8333 16.024 12.7104 15.7272 12.4916 15.5085C12.2728 15.2897 11.9761 15.1667 11.6667 15.1667H4.66667C4.35725 15.1667 4.0605 15.2897 3.84171 15.5085C3.62292 15.7272 3.5 16.024 3.5 16.3334V23.3334C3.5 23.6428 3.62292 23.9396 3.84171 24.1584C4.0605 24.3772 4.35725 24.5001 4.66667 24.5001ZM5.83333 17.5001H10.5V22.1667H5.83333V17.5001Z"
          fill="currentColor"
        />
        <path
          d="M16.3332 24.5001H23.3332C23.6426 24.5001 23.9393 24.3772 24.1581 24.1584C24.3769 23.9396 24.4998 23.6428 24.4998 23.3334V16.3334C24.4998 16.024 24.3769 15.7272 24.1581 15.5085C23.9393 15.2897 23.6426 15.1667 23.3332 15.1667H16.3332C16.0238 15.1667 15.727 15.2897 15.5082 15.5085C15.2894 15.7272 15.1665 16.024 15.1665 16.3334V23.3334C15.1665 23.6428 15.2894 23.9396 15.5082 24.1584C15.727 24.3772 16.0238 24.5001 16.3332 24.5001ZM17.4998 17.5001H22.1665V22.1667H17.4998V17.5001Z"
          fill="currentColor"
        />
      </svg>
      Manage Ads
    </a>

    <a
      routerLink="ad-balance"
      [routerLinkActiveOptions]="{ exact: true }"
      routerLinkActive="bg-[#F1E4F8] !text-[#AB54DB] [&_svg]:!text-[#AB54DB]"
      class="flex items-center px-4 py-3 text-slate-600 rounded-xl hover:bg-gray-50 group text-base font-medium"
      (click)="sidebarService.toggleSidebar()"
    >
      <svg
        viewBox="0 0 28 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="h-5 w-5 mr-4 text-[#B9BBBD]"
        stroke="currentColor"
        stroke-width="0.5"
      >
        <path
          d="M5.8335 24.5H22.1668C23.0951 24.5 23.9853 24.1313 24.6417 23.4749C25.2981 22.8185 25.6668 21.9283 25.6668 21V7C25.6668 6.07174 25.2981 5.1815 24.6417 4.52513C23.9853 3.86875 23.0951 3.5 22.1668 3.5H5.8335C4.90524 3.5 4.015 3.86875 3.35862 4.52513C2.70225 5.1815 2.3335 6.07174 2.3335 7V21C2.3335 21.9283 2.70225 22.8185 3.35862 23.4749C4.015 24.1313 4.90524 24.5 5.8335 24.5ZM23.3335 15.1667H17.5002V12.8333H23.3335V15.1667ZM4.66683 7C4.66683 6.69058 4.78975 6.39383 5.00854 6.17504C5.22733 5.95625 5.52408 5.83333 5.8335 5.83333H22.1668C22.4763 5.83333 22.773 5.95625 22.9918 6.17504C23.2106 6.39383 23.3335 6.69058 23.3335 7V10.5H16.3335C16.0241 10.5 15.7273 10.6229 15.5085 10.8417C15.2897 11.0605 15.1668 11.3572 15.1668 11.6667V16.3333C15.1668 16.6428 15.2897 16.9395 15.5085 17.1583C15.7273 17.3771 16.0241 17.5 16.3335 17.5H23.3335V21C23.3335 21.3094 23.2106 21.6062 22.9918 21.825C22.773 22.0438 22.4763 22.1667 22.1668 22.1667H5.8335C5.52408 22.1667 5.22733 22.0438 5.00854 21.825C4.78975 21.6062 4.66683 21.3094 4.66683 21V7Z"
          fill="currentColor"
        />
      </svg>

      Ad Balance
    </a>

    <a
      routerLink="pixel-tracking"
      [routerLinkActiveOptions]="{ exact: true }"
      routerLinkActive="bg-[#F1E4F8] !text-[#AB54DB] [&_svg]:!text-[#AB54DB]"
      class="flex items-center px-4 py-3 text-slate-600 rounded-xl hover:bg-gray-50 group text-base font-medium"
      (click)="sidebarService.toggleSidebar()"
    >
      <svg
        viewBox="0 0 28 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="h-5 w-5 mr-4 text-[#B9BBBD]"
        stroke="currentColor"
        stroke-width="0.5"
      >
        <g clip-path="url(#clip0_1157_1625)">
          <path
            d="M21.4669 11.2C24.5549 11.2 27.0669 8.68802 27.0669 5.6C27.0669 2.51198 24.5549 0 21.4669 0C18.3789 0 15.8669 2.51198 15.8669 5.6C15.8669 6.26377 15.9891 6.89803 16.2019 7.48934L10.8858 10.4833C9.85837 9.21416 8.29009 8.4 6.53359 8.4C3.44558 8.4 0.933594 10.912 0.933594 14C0.933594 17.088 3.44558 19.6 6.53359 19.6C8.29009 19.6 9.85837 18.7858 10.8858 17.5167L16.2019 20.5107C15.9891 21.102 15.8669 21.7362 15.8669 22.4C15.8669 25.488 18.3789 28 21.4669 28C24.5549 28 27.0669 25.488 27.0669 22.4C27.0669 19.312 24.5549 16.8 21.4669 16.8C19.7104 16.8 18.1422 17.6142 17.1147 18.8833L11.7986 15.8893C12.0115 15.298 12.1336 14.6638 12.1336 14C12.1336 13.3362 12.0115 12.702 11.7986 12.1107L17.1147 9.1167C18.1422 10.3858 19.7104 11.2 21.4669 11.2ZM21.4669 18.6667C23.5259 18.6667 25.2003 20.341 25.2003 22.4C25.2003 24.459 23.5259 26.1333 21.4669 26.1333C19.4079 26.1333 17.7336 24.459 17.7336 22.4C17.7336 20.341 19.4079 18.6667 21.4669 18.6667ZM6.53359 17.7333C4.47461 17.7333 2.80026 16.059 2.80026 14C2.80026 11.941 4.47461 10.2667 6.53359 10.2667C8.59257 10.2667 10.2669 11.941 10.2669 14C10.2669 16.059 8.59257 17.7333 6.53359 17.7333ZM21.4669 1.86667C23.5259 1.86667 25.2003 3.54102 25.2003 5.6C25.2003 7.65898 23.5259 9.33333 21.4669 9.33333C19.4079 9.33333 17.7336 7.65898 17.7336 5.6C17.7336 3.54102 19.4079 1.86667 21.4669 1.86667Z"
            fill="currentColor"
          />
        </g>
        <defs>
          <clipPath id="clip0_1157_1625">
            <rect width="28" height="28" fill="white" />
          </clipPath>
        </defs>
      </svg>

      Tracking
    </a>

    <a
      [routerLink]="['account']"
      [routerLinkActiveOptions]="{ exact: true }"
      routerLinkActive="bg-[#F1E4F8] !text-[#AB54DB] [&_svg]:!text-[#AB54DB]"
      class="flex items-center px-4 py-3 text-slate-600 rounded-xl hover:bg-gray-50 group text-base font-medium"
      (click)="sidebarService.toggleSidebar()"
    >
      <svg
        viewBox="0 0 28 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="h-5 w-5 mr-4 text-[#B9BBBD]"
        stroke="currentColor"
        stroke-width="0.5"
      >
        <path
          d="M18.1652 13.6148C19.1635 12.763 19.8766 11.6256 20.2084 10.3559C20.5401 9.08623 20.4747 7.74536 20.0207 6.51406C19.5668 5.28276 18.7463 4.22024 17.6698 3.46975C16.5932 2.71926 15.3125 2.31689 14.0002 2.31689C12.6879 2.31689 11.4071 2.71926 10.3306 3.46975C9.25404 4.22024 8.4335 5.28276 7.97958 6.51406C7.52566 7.74536 7.46018 9.08623 7.79197 10.3559C8.12377 11.6256 8.83688 12.763 9.83516 13.6148C7.63047 14.4574 5.73319 15.9489 4.39385 17.8923C3.05451 19.8356 2.3361 22.1396 2.3335 24.4998C2.3335 24.8092 2.45641 25.106 2.6752 25.3247C2.894 25.5435 3.19074 25.6665 3.50016 25.6665C3.80958 25.6665 4.10633 25.5435 4.32512 25.3247C4.54391 25.106 4.66683 24.8092 4.66683 24.4998C4.66683 22.0244 5.65016 19.6505 7.4005 17.9001C9.15084 16.1498 11.5248 15.1665 14.0002 15.1665C16.4755 15.1665 18.8495 16.1498 20.5998 17.9001C22.3502 19.6505 23.3335 22.0244 23.3335 24.4998C23.3335 24.8092 23.4564 25.106 23.6752 25.3247C23.894 25.5435 24.1907 25.6665 24.5002 25.6665C24.8096 25.6665 25.1063 25.5435 25.3251 25.3247C25.5439 25.106 25.6668 24.8092 25.6668 24.4998C25.6642 22.1396 24.9458 19.8356 23.6065 17.8923C22.2671 15.9489 20.3699 14.4574 18.1652 13.6148ZM14.0002 12.8331C13.1926 12.8331 12.4031 12.5936 11.7316 12.145C11.0601 11.6963 10.5367 11.0585 10.2277 10.3124C9.9186 9.56628 9.83773 8.74526 9.99529 7.95317C10.1528 7.16108 10.5417 6.4335 11.1128 5.86244C11.6839 5.29137 12.4115 4.90247 13.2035 4.74492C13.9956 4.58736 14.8167 4.66822 15.5628 4.97728C16.3089 5.28634 16.9467 5.80971 17.3953 6.48121C17.844 7.15271 18.0835 7.94218 18.0835 8.74979C18.0835 9.83276 17.6533 10.8714 16.8875 11.6371C16.1217 12.4029 15.0831 12.8331 14.0002 12.8331Z"
          fill="currentColor"
        />
      </svg>

      Account
    </a>

    <a
      routerLink="guides"
      [routerLinkActiveOptions]="{ exact: true }"
      routerLinkActive="bg-[#F1E4F8] !text-[#AB54DB] [&_svg]:!text-[#AB54DB]"
      class="flex items-center px-4 py-3 text-slate-600 rounded-xl hover:bg-gray-50 group text-base font-medium"
      (click)="sidebarService.toggleSidebar()"
    >
      <svg
        viewBox="0 0 28 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="h-5 w-5 mr-4 text-[#B9BBBD]"
        stroke="currentColor"
        stroke-width="0.5"
      >
        <path
          d="M14.0003 1.16663C11.4621 1.16663 8.98095 1.91929 6.87051 3.32943C4.76008 4.73958 3.1152 6.74387 2.14388 9.08885C1.17255 11.4338 0.91841 14.0142 1.41359 16.5036C1.90876 18.993 3.13102 21.2797 4.9258 23.0745C6.72057 24.8693 9.00725 26.0915 11.4967 26.5867C13.9861 27.0819 16.5665 26.8277 18.9114 25.8564C21.2564 24.8851 23.2607 23.2402 24.6709 21.1298C26.081 19.0193 26.8337 16.5382 26.8337 14C26.8297 10.5976 25.4763 7.3357 23.0704 4.92986C20.6646 2.52401 17.4027 1.17064 14.0003 1.16663ZM14.0003 24.5C11.9236 24.5 9.89356 23.8841 8.16684 22.7304C6.44013 21.5766 5.09432 19.9368 4.2996 18.0181C3.50488 16.0995 3.29694 13.9883 3.70209 11.9515C4.10723 9.91471 5.10726 8.04379 6.57571 6.57534C8.04416 5.10689 9.91508 4.10686 11.9519 3.70171C13.9887 3.29657 16.0999 3.5045 18.0185 4.29922C19.9371 5.09394 21.577 6.43976 22.7308 8.16647C23.8845 9.89319 24.5003 11.9233 24.5003 14C24.4969 16.7837 23.3896 19.4524 21.4212 21.4208C19.4528 23.3892 16.7841 24.4966 14.0003 24.5Z"
          fill="currentColor"
        />
        <path
          d="M16.576 6.60924C15.9115 6.1718 15.1476 5.90873 14.3546 5.8443C13.5617 5.77987 12.7653 5.91615 12.0389 6.24057C11.2197 6.60479 10.5261 7.20248 10.0449 7.95886C9.56365 8.71525 9.31616 9.59675 9.33336 10.4931V10.5001C9.33429 10.8095 9.45809 11.1059 9.67754 11.324C9.89699 11.5421 10.1941 11.6642 10.5035 11.6632C10.8129 11.6623 11.1093 11.5385 11.3275 11.3191C11.5456 11.0996 11.6676 10.8025 11.6667 10.4931C11.6548 10.0565 11.7697 9.62575 11.9974 9.25305C12.2252 8.88036 12.5561 8.58165 12.95 8.39307C13.3216 8.21806 13.7318 8.14119 14.1415 8.16978C14.5512 8.19837 14.9467 8.33148 15.2904 8.55641C15.5971 8.75928 15.8515 9.03178 16.0329 9.35169C16.2143 9.6716 16.3176 10.0299 16.3342 10.3972C16.3508 10.7646 16.2803 11.1307 16.1285 11.4657C15.9767 11.8007 15.7479 12.095 15.4607 12.3247C14.6621 12.9346 14.0113 13.7166 13.5564 14.6126C13.1016 15.5085 12.8544 16.4955 12.8334 17.5001C12.8339 17.6533 12.8646 17.8049 12.9237 17.9462C12.9829 18.0876 13.0692 18.2159 13.178 18.3238C13.2867 18.4318 13.4156 18.5173 13.5573 18.5754C13.6991 18.6335 13.8509 18.6632 14.0041 18.6627C14.1573 18.6621 14.3089 18.6314 14.4503 18.5723C14.5916 18.5132 14.7199 18.4268 14.8279 18.3181C14.9358 18.2093 15.0213 18.0804 15.0794 17.9387C15.1376 17.7969 15.1672 17.6451 15.1667 17.4919C15.1891 16.838 15.3579 16.1976 15.6608 15.6176C15.9637 15.0377 16.3929 14.5332 16.9167 14.1412C17.49 13.6815 17.9467 13.093 18.2495 12.4234C18.5523 11.7538 18.6927 11.0222 18.6593 10.2881C18.6259 9.55397 18.4196 8.83813 18.0571 8.19885C17.6947 7.55957 17.1864 7.01492 16.5737 6.60924H16.576Z"
          fill="currentColor"
        />
        <path
          d="M13.9997 22.1667C14.644 22.1667 15.1663 21.6444 15.1663 21C15.1663 20.3557 14.644 19.8334 13.9997 19.8334C13.3553 19.8334 12.833 20.3557 12.833 21C12.833 21.6444 13.3553 22.1667 13.9997 22.1667Z"
          fill="currentColor"
        />
      </svg>

      Training Hub
    </a>
  </nav>

  <!-- Footer -->
  <div class="px-8 py-6">
    <div class="text-xs text-slate-500">
      <p class="text-[#464255] text-[16px] font-semibold">Authoritie, LLC</p>
      <p class="text-gray-500 text-[12px]">
        <span class="text-[#A3A3A3]"> © {{ currentYear }} Copyright - Made with </span>
        ❤️
      </p>
    </div>
  </div>
</aside>
